module.exports = __webpack_public_path__ + "static/img/pin-trap-active.2e47516.svg";